import {Component, Input, OnInit} from '@angular/core';
import {inOutAnimation} from '../../animations';

@Component({
    selector: 'lv-info-text-tooltip-collapsable',
    templateUrl: './info-text-tooltip-collapsable.component.html',
    styleUrls: ['./info-text-tooltip-collapsable.component.scss'],
    animations: [inOutAnimation],
    standalone: false
})
export class InfoTextTooltipCollapsableComponent implements OnInit {

  @Input()
  public showInfotext: boolean;

  @Input()
  public tooltip: string;

  constructor() {
  }

  ngOnInit(): void {
  }

}
